<template>
  <CustomPage title="设置">
    <div slot="content" class="content">
      <div class="top">
        <div class="head" @click="bindWechat">
          <div class="label">
            <img :src="wechat_info.flag ? wechat_info.headImgUrl : wechat_default_avatar" alt="" />
            <span>{{ wechat_info.flag ? '微信账号' : '绑定微信' }}</span>
          </div>
          <div class="value">
            <span>{{ wechat_info.flag ? wechat_info.nickname : '' }}</span>
            <img :src="require('@/assets/setting/箭头1.svg')" alt="" />
          </div>
        </div>
        <div class="tips">
          <p>1.账号关联之后，用户可使用快捷登录进入商城</p>
          <p>2.为了您的账号安全，30天内不可解除账号关联</p>
        </div>
        <div class="menu van-hairline--top">
          <template v-for="item in menu">
            <div
              v-if="item.show"
              class="cell van-hairline--bottom"
              :key="item.label"
              @click="cellClick(item.router)"
            >
              <div class="label">
                <img :src="item.icon" alt="" />
                <span>{{ item.label }}</span>
              </div>
              <div class="value">
                <img :src="require('@/assets/setting/箭头.svg')" alt="" />
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="btn" @click="logout">退出账号</div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import { mapGetters } from 'vuex'
import { bindWechat, getAppId, getBindWechatInfo } from '@/api/login'
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import { Toast } from 'vant'
export default {
  components: { CustomPage, CustomView },
  created() {
    if (this.$route.query.code) {
      this.bindWechatHandle(this.$route.query.code)
    }
    this.getBindWechatInfo()
  },
  data() {
    return {
      wechat_default_avatar: require('@/assets/setting/微信.svg'),
      wechat_info: {
        flag: false,
        nickname: null,
        headImgUrl: null,
      },
      menu: [
        {
          icon: require('@/assets/setting/基础信息.svg'),
          label: '基础信息',
          router: 'SettingBaseInfo',
          show: true
        },
        {
          icon: require('@/assets/setting/发票信息.svg'),
          label: '发票信息',
          router: 'SettingInvoice',
          show: true
        },
        {
          icon: require('@/assets/setting/收货地址.svg'),
          label: '收货地址',
          router: 'SettingAddress',
          show: true
        },
        {
          icon: require('@/assets/setting/账户安全.svg'),
          label: '账户安全',
          router: 'SettingSafe',
          show: true
        },
        {
          icon: require('@/assets/setting/关于我们.svg'),
          label: '关于我们',
          router: 'SettingAboutUs',
          show: true
        },
        {
          icon: require('@/assets/setting/输入邀请码.svg'),
          label: '输入邀请码',
          router: 'SettingInviteCode',
          show: false
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['distributionFlag']),
  },
  mounted() {
    this.menu[this.menu.length - 1].show = this.distributionFlag === false
  },
  methods: {
    getBindWechatInfo() {
      getBindWechatInfo().then(res => {
        const data = res.data
        if (data) {
          this.wechat_info.flag = data.openId && !data.openId.startsWith('fake')
          this.wechat_info.nickname = data.nickname
          this.wechat_info.headImgUrl = data.headImgUrl
        }
      })
    },
    cellClick(name) {
      this.$router.push({ name })
    },
    logout() {
      this.$store.dispatch('user/resetToken')
      this.$router.push('/login')
    },
    bindWechat() {
      if (this.wechat_info.flag) {
        return
      }
      this.$store.dispatch('app/showLoading')
      getAppId().then(res => {
        this.$store.dispatch('app/hideLoading')
        this.wechatAuth(res.data)
      }).catch(() => {
        this.$store.dispatch('app/hideLoading')
      })
    },
    wechatAuth(appId) {
      const href = window.location.origin + this.$route.path + '?' + this.filterCodeByParams()
      const redirect_uri = encodeURIComponent(href)
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
    },
    // 过滤掉 code 参数
    filterCodeByParams() {
      const queryList = []
      for (const key in this.$route.query) {
        if (Object.hasOwnProperty.call(this.$route.query, key)) {
          if (key !== 'code') {
            queryList.push(`${key}=${this.$route.query[key]}`)
          }
        }
      }
      return queryList.join('&')
    },
    bindWechatHandle(code) {
      bindWechat({ code }).then(res => {
        Toast.success('成功绑定微信')
        this.getBindWechatInfo()
      })
      .catch(() => {})
    }
  },
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 22px 24px;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 28px;
    font-size: 28px;
    box-shadow: 0px 4px 12px 0px rgba(153, 153, 153, 0.1);
    border-radius: 12px;
    .label {
      display: flex;
      align-items: center;
      img {
        display: inline-block;
        width: 64px;
        height: 64px;
        margin-right: 34px;
      }
    }
    .value {
      display: flex;
      align-items: center;
      img {
        display: inline-block;
        width: 28px;
        margin-left: 18px;
      }
    }
  }
  .tips {
    color: #c4c4c6;
    font-size: 22px;
    line-height: 1.63em;
    margin: 40px 0;
  }
  .menu {
    &::after {
      border-color: #f2f2f2;
    }
    .cell {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 28px;
      padding: 24px 0;
      &::after {
        border-color: #f2f2f2;
      }
      img {
        display: inline-block;
      }
      .label {
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
          margin-right: 10px;
        }
      }
      .value {
        img {
          width: 26px;
          height: 26px;
        }
      }
    }
  }
  .btn {
    margin-bottom: 80px;
    line-height: 68px;
    font-size: 28px;
    text-align: center;
    color: #fff;
    background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
    border-radius: 38px;
    border: 2px solid #fe6979;
  }
}
</style>